import { createFileRoute } from "@tanstack/react-router";
import { VerifyGameAccountPage } from "@/features/game/verify-account/verify-game-account-page";

export const Route = createFileRoute("/_index/verify-game-account")({
  component: RouteComponent,
  staticData: {
    title: "验证游戏账号",
  },
  head: () => ({
    meta: [{ name: "robots", content: "noindex,nofollow" }],
  }),
});

function RouteComponent() {
  return <VerifyGameAccountPage />;
}
